import React from "react";
import { Table, List, Space, Row, Col, Typography } from "antd";
import { ListRecordAttributeItem } from 'components';
import moment from 'moment';
import { actionLabel, otherActions, standardActionFlags } from 'common/permissionActions';

const { Column } = Table;
const { Title, Text, Link } = Typography;

const displayLabels = {
    "name": "Name",
    "description": "Description",
    "canAdd": "Add",
    "canView": "View",
    "canEdit": "Edit",
    "canDelete": "Delete",
    "otherActions": "Other actions",
    "active": "Active",
    "updatedByEmail": "Updated by",
    "updatedDate": "Updated at",
    "deleted": "Deleted"
}

// The four standard actions as flags, and any other action (e.g. Review) as one line.
export function parseAction(permission) {
    if (permission && permission.actions) {
        Object.assign(permission, standardActionFlags(permission.actions));
        permission.otherActions = otherActions(permission.actions).map(actionLabel).join(", ");
        delete permission.actions;
    }
}

export default function ({ record }) {
    let currentData = { ...record.data };
    let previousData = { ...(record.previousData || {}) };
    if (currentData) {
        parseAction(currentData);
    }
    if (previousData) {
        parseAction(previousData);
    }
    // The Other actions line only for a permission that has, or had, any.
    if (!currentData.otherActions && !previousData.otherActions) {
        delete currentData.otherActions;
    }
    return <>
        <Row className="middle-row">
            <Col span={24}>
                <Title level={5}><Text>{record.name}</Text></Title>
            </Col>
        </Row>
        <Row>
            <Col span={24}>
                <List
                    size="small"
                    bordered
                    dataSource={Object.keys(currentData)}
                    renderItem={item => {
                        if (displayLabels[item]) {
                            if (item === "updatedDate") {
                                return <ListRecordAttributeItem name={displayLabels[item]} value={moment.utc(currentData[item]).toDate().toLocaleString()} previousValue={previousData[item] && moment.utc(previousData[item]).toDate().toLocaleString()}></ListRecordAttributeItem>
                            }
                            return <ListRecordAttributeItem name={displayLabels[item]} value={currentData[item]} previousValue={previousData && previousData[item]}></ListRecordAttributeItem>
                        }
                        return <></>
                    }}
                />
            </Col>
        </Row>
    </>
}